import {
  Component,
  OnDestroy,
  OnInit,
  Type,
  ViewEncapsulation,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { skipWhile, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {
  returnUrl: string;
  rememberMe = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.sub = this.authService.isAuthenticated
      .pipe(
        skipWhile((value) => value === null),
        take(1)
      )
      .subscribe((authenticated) => {
        if (authenticated) {
          setTimeout(() => {
            this.navigate();
          }, 350);
        } else {
          console.log('idi na login');
          this.isStarting = false;
        }
      });
  }

  sub: Subscription;
  // error = {} as IError;
  isLoading = false;
  isStarting = false;

  user;

  ngOnInit(): void {
    console.log('LOGIN COMP');
  }

  /**
   * Navigate user by role if authenticated.
   */
  navigate() {
    this.authService.LoggedinUser.pipe(
      skipWhile((value) => value === null),
      take(1)
    ).subscribe((user) => {
      if (user) {
        switch (user.role.name) {
          case Role.ROOT:
            this.returnUrl =
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/root';
            this.router.navigateByUrl(this.returnUrl);
            // this.isStarting = false;
            break;
          case Role.USER:
            this.router.navigateByUrl(
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/'
            );
            break;
          case Role.WORKER:
            this.router.navigateByUrl(
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/worker'
            );
            break;
          case Role.FILIALADMIN:
            this.router.navigateByUrl(
              this.activatedRoute.snapshot.queryParams['returnUrl'] || '/admin'
            );
            break;
        }
      }
    });
  }

  /**
   * is for attempting to login with username and password.
   * @param e
   * @param loginForm - is Angluar NgForm with email and password
   * @returns
   */
  attemptToLogin(e: KeyboardEvent, loginForm: NgForm) {
    if (e.repeat) {
      return;
    }

    if (loginForm.invalid) {
      return;
    }

    // this.error.message = '';
    this.isLoading = true;

    const { userEmail, userPassword } = loginForm.value;

    this.authService.login(userEmail, userPassword, this.rememberMe).subscribe(
      (response) => {
        this.isLoading = false;
        this.navigate();
      },
      (err) => {
        // this.error = err;
        this.isLoading = false;
        if (err.error.errorCode === 4030000) {
          this.translate
            .get('login.wrongCredentials')
            .subscribe((text: string) => {
              this.toastr.error(text);
            });
        } else {
          this.toastr.error(err.error.description);
        }
      }
    );
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }
}
